import CardRowSegment from "components/CardRowSegment/CardRowSegment";
import React from "react";

interface Props {
  billingDetails: server.dto.ClientBillingDetails
}

const ContactRow = (props: Props) => (<CardRowSegment className="margin-bottom" type="lined">

  <CardRowSegment.Header>{RESX.Financial.Finance}</CardRowSegment.Header>

  <strong>{props.billingDetails.contact.name.fullName}</strong>
  <div>
    {props.billingDetails.contactEmail}
  </div>
</CardRowSegment>);

export default ContactRow;